import * as React from "react";
const SvgLiveData20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: 20,
        height: 16,
        viewBox: "0 0 20 16",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      d: "m7.8 11.08.07.04-1.11 1.66-.02-.01C5.11 11.76 4 9.97 4 7.93c0-2 1.06-3.75 2.63-4.78l1.15 1.64C6.69 5.47 6 6.63 6 7.93s.7 2.46 1.8 3.15zm-2.21 2.91.25.18-1.11 1.67-.31-.23A9.478 9.478 0 0 1 .5 7.93C.5 4.77 2.04 1.97 4.41.25l.11-.08L5.67 1.8l-.08.06A7.462 7.462 0 0 0 2.5 7.93c0 2.49 1.21 4.7 3.09 6.06zm10 1.62-.31.23-1.11-1.67.25-.18a7.503 7.503 0 0 0 3.09-6.07c0-2.49-1.21-4.7-3.09-6.07l-.09-.05L15.48.17l.11.08a9.482 9.482 0 0 1 3.91 7.68c0 3.15-1.54 5.95-3.91 7.68zm-2.33-2.84-.02.01-1.11-1.66.07-.04c1.1-.68 1.8-1.85 1.8-3.15 0-1.29-.69-2.45-1.78-3.14l1.15-1.64C14.94 4.18 16 5.92 16 7.93c0 2.04-1.11 3.83-2.74 4.84zM10 5.93c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2a2 2 0 0 0-2-2z",
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    })
  );
export default SvgLiveData20Px;
